// based imports router
import { h } from 'vue';
import { createRouter, createWebHistory, RouterView } from 'vue-router';

// import middleware
import Middleware from './middleware.js';

// first views import
import HomeView from '@/views/Home.vue';

// import translation
import Tr from "@/i18n/translation";

import Wrapper from '@/theme/layouts/Wrapper.vue';

// Recupero la gerarchia di ruoli
const roleHierarchy = Middleware.getRoleHierarchy();

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: [
    {
      path: "/:locale?",
      component: Wrapper,
      beforeEnter: Tr.routeMiddleware,
      children: [
        // Login non usa il layout Wrapper
        {
          path: 'login',
          name: 'login',
          component: () => import('@/views/auth/Login.vue'),
          meta: { requiresAuth: false }
        },

        // Tutte le altre route usano il layout Wrapper
        {
          path: '',
          name: 'home',
          component: () => import('@/views/Home.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'sendEmail',
          name: 'sendEmail',
          component: () => import('@/views/sendEmail/sendEmail.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'emailHistory',
          name: 'emailHistory',
          component: () => import('@/views/emailHistory/NewEmailHistory.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'contacts',
          name: 'contacts',
          component: () => import('@/views/contacts/NewContacts.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'contact-lists',
          name: 'contact-lists',
          component: () => import('@/views/contacts/ContactLists.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'templates',
          name: 'templates',
          component: () => import('@/views/templates/NewTemplates.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'users',
          name: 'users',
          component: () => import('@/views/users/Users.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'template-generator',
          name: 'template-generator',
          component: () => import('@/views/template-generator/TemplateGeneratorView.vue'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: () => import('@/views/404.vue'),
      meta: { requiresAuth: false }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0, behavior: 'smooth' };
  }
});

// Middleware per l'autenticazione
router.beforeEach(Middleware.handleRoute);

export default router;
